import { ModuleLayout } from '@billy/design-system'
import React, { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router'

import { useOrganizationViewUrl } from '../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../utils/routing/reactRoute'
import { EInvoicesSectionMessage } from './elements/EInvoicesSectionMessage'
import { InvoicesSideActions } from './elements/InvoicesSideActions.tsx/InvoicesSideActions'
import { InvoicesSummary } from './elements/InvoicesSummary'
import { InvoicesTable } from './elements/InvoicesTable'
import { InvoicesTableActions } from './elements/InvoicesTableActions'
import { useInvoicesListFilters } from './hooks/useInvoicesListFilters'
import { useIsInvoicesListEmpty } from './hooks/useIsInvoicesListEmpty'

export const InvoicesList = (): ReactElement | null => {
  const { t } = useTranslation()
  const { isInvoicesListEmpty } = useIsInvoicesListEmpty()
  const [{ contactId, contactName }] = useInvoicesListFilters()
  const { url: invoicesListEmptyUrl } = useOrganizationViewUrl(reactRoute.organization.invoices.getListEmptyRoute())

  const title = useMemo(
    () => (contactId && contactName ? t('invoicesTo', { contactName }) : t('invoices')),
    [contactId, contactName, t],
  )

  if (!invoicesListEmptyUrl) {
    return null
  }

  if (isInvoicesListEmpty) {
    return <Navigate to={invoicesListEmptyUrl} replace />
  }

  return (
    <ModuleLayout sideActions={<InvoicesSideActions />} title={title}>
      <EInvoicesSectionMessage />
      <InvoicesSummary />
      <InvoicesTableActions />
      <InvoicesTable />
    </ModuleLayout>
  )
}
